import { useLocation } from 'react-router-dom';

export type DisplayMode = 'embed' | 'landing';

/**
 * Detect whether the app is running in embed or landing (full page) mode
 * 
 * Mode is determined ONLY by URL path:
 * - /embed/* routes = embed mode
 * - All other routes = landing mode
 * 
 * Note: We intentionally don't check for iframe detection because
 * landing pages can be displayed in iframes (e.g., demo showcase's
 * standalone portal mode) and should still function as landing pages.
 */
export function useDisplayMode(): DisplayMode {
  const location = useLocation();

  // URL-based detection - explicit embed routes
  if (location.pathname.startsWith('/embed/')) {
    return 'embed';
  }

  return 'landing';
}

/**
 * Get theme from URL params or default
 */
export function useTheme(): 'light' | 'dark' | 'auto' {
  const searchParams = new URLSearchParams(window.location.search);
  const theme = searchParams.get('theme');

  if (theme === 'dark') return 'dark';
  if (theme === 'light') return 'light';

  return 'auto';
}
